export const PRODUCT_NAME = "RealtiTrust";
